// Import HTMX
window.htmx = require('htmx.org');

require('./alpine-components.js')

// Import alpine.js
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
Alpine.plugin(focus)
Alpine.start()
window.Alpine = Alpine
